export type CopyrightProps = {
  slim?: boolean;
};

export function Copyright({ slim }: CopyrightProps) {
  return (
    <div className="bp6-text-muted">
      {slim ? "" : "Copyright "}
      {"© "}
      <a href="https://panoscape.com/">PanoScape</a> {new Date().getFullYear()}
      {"."}
    </div>
  );
}
